import { useState } from "react";
import { Button } from "react-bootstrap";
import emailjs from '@emailjs/browser';
import IsLoadingContact from "../IsLoading/IsLoadingContact";
import "./contact.css";

const Contact = () => {
	const [email, setEmail] = useState("");
	const [sujet, setSujet] = useState("");
	const [message, setMessage] = useState("");
	const [response, setResponse] = useState("");
	const [isLoading, setIsLoading] = useState(false);

	const handleForm = async (e) => {
		e.preventDefault();


		
		// Validation simple
		if (!email || !sujet || !message) {
			setResponse("Veuillez remplir tous les champs");
			setTimeout(() => setResponse(""), 3000);
			return;
		}

		setIsLoading(true);

		// Paramètres du template EmailJS
		const templateParams = {
			email: email,
			subject: sujet,
			message: message,
			to_email: 'laboitazik@orange.fr', // Email de destination
		};

		try {
			const result = await emailjs.send(
				process.env.REACT_APP_EMAILJS_SERVICE_ID,
				process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
				templateParams,
				process.env.REACT_APP_EMAILJS_PUBLIC_KEY
			);

			if (result.status === 200) {
				setIsLoading(false);
				setEmail("");
				setSujet("");
				setMessage("");
				setResponse("Message envoyé avec succès !");
				setTimeout(() => {
					setResponse("");
				}, 3000);
			}
		} catch (error) {
			console.error('Erreur EmailJS:', error);
			setIsLoading(false);
			setResponse(
				"Une erreur est survenue lors de l'envoi du message. Vous pouvez nous contacter directement à : laboitazik17@gmail.com"
			);
			setTimeout(() => {
				setResponse("");
			}, 5000);
		}
	};
	return (
		<form id="contact" onSubmit={(e) => handleForm(e)}>
			<input
				type="email"
				name="email"
				id="email"
				placeholder="Votre email"
				value={email}
				onChange={(e) => {
					setEmail(e.target.value);
				}}
			/>
			<input
				type="text"
				name="nom"
				id="nom"
				value={sujet}
				placeholder="Sujet du message"
				onChange={(e) => {
					setSujet(e.target.value);
				}}
			/>
			<textarea
				placeholder="Votre message"
				value={message}
				onChange={(e) => {
					setMessage(e.target.value);
				}}
			></textarea>
			<Button
				variant="custom"
				className="btn-custom rose btnContact"
				type="submit"
			>
				{isLoading ? <IsLoadingContact /> : "ENVOYER LE MESSAGE"}
			</Button>
			<div className="responseContact">{response}</div>
		</form>
		
	);

};

export default Contact;
